export default __webpack_public_path__ + "static/media/undeadminionlifestealer.6bbfa956.png";